import { useMutation } from "@apollo/client";


















































export const useDataClientMutation = useMutation;
